import {Navigation} from "./Navigation";
import {useEffect, useState} from "react";
import Auth from "../api/auth";
import { fetchUserDetails } from '../api/endpoints/user';
import MarketingTags from "../components/MarketingTags";
import RouteGuard from "../routes/RouteGuard";
import PublicRouteGuard from "../routes/PublicRouteGuard";
import { routeReplacesSession } from "../routes/routeConfig";
import { setAuthFailureHandler, resetAuthFailureFlag } from "../utils/authFailureHandler";
import { queryClient } from "../config/queryClient";
import { AlertsUIProvider } from "../context/AlertsUIContext";
import { AuthProvider } from "../context/AuthContext";
import { AlertProvider, AlertOutlet } from "../context/AlertContext";


function App() {
    console.log('render main')
    const [auth, setAuth] = useState({isLoggedIn: false, cls: new Auth()})
    const [restoringSession, setRestoringSession] = useState(true);
    const [isSidebarOpen, setIsSidebarOpen] = useState(false); // desktop sidebar state

    // Restore the session from the refresh cookie on page load / refresh
    useEffect(() => {
        if (routeReplacesSession(window.location.pathname)) {
            // Invitation sign-up pages create a new account and sign in as it.
            // Opening one while logged in: revoke the refresh cookie instead of
            // restoring the session, so the form is shown rather than the
            // dashboard redirect (which dropped the invite token).
            auth.cls.logout();
            setRestoringSession(false);
            return;
        }
        auth.cls.restoreSession().then(async (restored) => {
            if (restored) {
                const userDetails = await fetchUserDetails(auth);
                setAuth(prev => ({
                    ...prev,
                    ...userDetails,
                    isLoggedIn: true
                }));
            }
            setRestoringSession(false);
        });
    }, []);

    useEffect(() => {
        if (auth.isLoggedIn) {
            resetAuthFailureFlag();
        }
    },[auth.isLoggedIn])

    useEffect(() => {
        setAuthFailureHandler(() => {
            auth.cls.logout();
            queryClient.clear();
            setAuth(prev => ({ ...prev, isLoggedIn: false }));
        });
    }, []);

    // Add dark mode class to body based on system preference
    useEffect(() => {
        const match = window.matchMedia("(prefers-color-scheme: dark)");
        const update = () => {
            if (match.matches) {
                document.body.classList.add("dark");
            } else {
                document.body.classList.remove("dark");
            }
        };
        update();
        match.addEventListener("change", update);
        return () => match.removeEventListener("change", update);
    }, []);

    // Avoid flashing the login modal while the session restore is in flight
    if (restoringSession) {
        return <div className="App" />;
    }

    return (
        <div className="App">
            <AuthProvider auth={auth} setAuth={setAuth}>
                <AlertProvider>
                    {!auth.isLoggedIn ? (
                        // Public routes - for unauthenticated users
                        <PublicRouteGuard auth={auth} setAuth={setAuth} isSidebarOpen={isSidebarOpen}/>
                    ) : (
                        // Protected routes - for authenticated users
                        <AlertsUIProvider>
                            <Navigation auth={auth} setAuth={setAuth} isSidebarOpen={isSidebarOpen} setIsSidebarOpen={setIsSidebarOpen}>
                                <AlertOutlet className="mx-8" />
                                <RouteGuard auth={auth} setAuth={setAuth} isSidebarOpen={isSidebarOpen}/>
                            </Navigation>
                        </AlertsUIProvider>
                    )}
                </AlertProvider>
            </AuthProvider>
            <MarketingTags />
        </div>
    );
}

export default App;
